(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();


if (!customElements.get('pp-paylater-div')) {

	class PpPaylaterDiv extends HTMLElement {
	  constructor() {
		super();
		this.LanguageList = ['DE', 'FR', 'ES', 'IT', 'GB'];
		this.init();
	  }
	  init() {
		this.currentCurrency = (window.localStorage.getItem('currentCurrency') || '').toUpperCase();
		this.lan_code = (window.localStorage.getItem('lan_code') || 'en').toUpperCase();
		this.price = "0";
		if (!this.currentCurrency) {
		  return
		}
		if (this.currentCurrency == "GBP") {
		  this.lan_code = "GB"
		} else if (this.currentCurrency == "EUR" && !this.LanguageList.includes(this.lan_code)) {
            this.lan_code = "DE"
        }
		var obj = document.querySelector('.product__info-container .price-item .langwill-money[data-currency=' + this.currentCurrency + ']');
		if (obj) {
		  this.price = obj.innerHTML.replace('$', '').replace('€', '');
		  try {
			document.querySelector('#paypal-paylater-container').innerHTML = '<p data-pp-message data-pp-placement="product" data-pp-amount="' + this.price + '" data-pp-buyerCountry="' + this.lan_code + '"  data-pp-style-text-color="white"></p>';
			this.loadScript('https://www.paypal.com/sdk/js?components=buttons,messages&client-id=AfOIlOme7DlIul9l9DV9_3Mnfp4FSlWF_57RfRv3v_poi5vTO2YP4hZfe6gM9L80p7XdrawvAwa1glHE&currency=' + this.currentCurrency + '&enable-funding=paylater')
		  } catch {

		  }
		} else {
		  setTimeout(() => {
			this.init();
		  }, 1000);
		}
	  }

	  loadScript(src, callback) {
		const script = document.createElement('script')
		script.src = src
		script.async = true

		script.onload = () => callback && callback()
		script.onerror = () => console.error('load error:', src)

		this.appendChild(script)
	  }

	}

	customElements.define('pp-paylater-div', PpPaylaterDiv);

  }